import React from "react";
import { useState } from "react";
import DoubleClickEdit from "../../../../../components/DoubleClickEdit";
import { XCircleIcon } from "@heroicons/react/solid";
import { MdAvTimer } from "react-icons/md";
import ReactDatePicker from "react-datepicker";
import { formatTaskDate } from "./taskDateFormatters";

/**
 * Inline double-click-editable "repeat until" date picker for a recurring task.
 * In client-portal mode renders a read-only "Until <date>" label (only shown
 * when a date is set). In advisor mode shows a date picker to set or clear
 * the repeat-until date. A null value represents "Forever".
 *
 * @param {object}   props
 * @param {Function} props.handleSubmitEdit - Called with the new Date value (or null) on change
 * @param {boolean}  props.isClientPortal   - Renders read-only client-portal view when true
 * @param {object}   props.task             - Task object; `task.repeat_until` seeds the initial value
 */
const RepeatUntil = ({ handleSubmitEdit, isClientPortal, task }) => {
    const [value, setValue] = useState(task.repeat_until);
    const [showEdit, setShowEdit] = useState(false);

    const handleChange = (newValue) => {
        setValue(newValue === "Forever" ? null : newValue);
        handleSubmitEdit(newValue);
        setShowEdit(false);
    };

    const handleClearValue = () => {
        setValue(null);
        handleSubmitEdit(null);
        setShowEdit(false);
    }


    return (
        <>


            {isClientPortal ?
                <div className="flex items-center text-xs text-gray-500">
                    {task?.repeat_until ? (
                        <div className="flex items-center gap-1">
                            <MdAvTimer
                                className="mr-1 h-3.5 w-3.5 flex-shrink-0 text-gray-400"
                                aria-hidden="true"
                            />
                            <span>Until {formatTaskDate(value)}</span>
                        </div>
                    ) : null}
                </div> :
                <DoubleClickEdit
                    showEdit={showEdit}
                    setShowEdit={setShowEdit}
                    defaultComponent={
                        <div className="flex items-center text-xs text-gray-500">
                            <MdAvTimer
                                className="mr-1 h-3.5 w-3.5 flex-shrink-0 text-gray-400"
                                aria-hidden="true"
                            />
                            {value ? (
                                <div className="group flex items-center gap-1">
                                    <span>Until {formatTaskDate(value)}</span>
                                    <button onClick={handleClearValue} aria-label="Clear repeat until" className="invisible group-hover:visible">
                                        <XCircleIcon className="h-3.5 w-3.5 text-gray-400" aria-hidden="true" />
                                    </button>
                                </div>
                            ) : (
                                <span className="min-w-max">Forever</span>
                            )}
                        </div>
                    }
                    editComponent={

                        <ReactDatePicker
                            className="input-primary "
                            selected={value}
                            onChange={(date) => handleChange(new Date(date))}
                        />

                    }
                    handleSubmitEdit={() => { }}
                    componentName="repeat_until"
                />}
        </>
    );
};

export default RepeatUntil;
